module.exports = __webpack_public_path__ + "static/media/feather.931c9e74.eot";